import React from 'react'
import '../../../styles/containers/SavingsCalculator/components/savings-card.scss';

function SavingsCard(props) {
    return (
        <div className={`savings-container d-flex flex-column justify-content-around ${props.selectedSavings?'savings-selected-border':''}`}>
            <div className={`d-flex justify-content-center savings-money ${props.color?'savings-selected-color':''}`}>{props.money}</div>
        </div>
    )
}

export default SavingsCard
